import React from 'react'
import { useTranslation } from 'react-i18next'

import DxDataTable from 'components/DxDataTable'
import { ContentBlock } from 'components/ContentBlock'
import { useQuery } from 'components/graphql'
import gql from 'graphql-tag'
import { Info as InfoIco } from 'media/icons'

const query = gql`
query tseCRs {
	cashAssist {
    listCashRegisters {
      id
      # cashRegisterType: Tablet-/App-Kassen-Systeme
      deviceType # detect if windows
      tseRemoteCashRegisterId
      hardwareId
      firstTransaction
      device {
      	hardwareId
        model
        vendor
        appVersion
      }
      tseInfo {
        serial
        cashRegisterId
        expirationDate
        activationDate
        info
        producer
        type
        bsi
        software
      }
      parameters {
        street
        postCode
        city
        tseIsActive
      }
      shop {
        id
        name
      }
    }
  }
}
`

const MeinElster = () => {
	const { data, loading } = useQuery(query)
	const [t] = useTranslation()

	return (
		<ContentBlock isLoading={loading} label={t('options_section.strings.tse_meinelster')}>
			<DxDataTable
				data={data?.listCashRegisters?.filter(cr => cr.parameters.tseIsActive) || []}
				toolBarActions={[{
					label: t('options_section.strings.tse_meinelster'),
					action: ()=> {
						window.open('https://www.elster.de/eportal/start', '_blank').focus()
					},
					Icon: InfoIco
				}]}
				columns={[{
					caption: t('options_section.strings.tse_shopName'),
					dataField: 'shop.name',
					// calculateGroupValue: (row) => `${row?.shop?.name || ''} ${row?.parameters?.city || ''} ${row?.parameters?.postCode || ''} ${row?.parameters?.street || ''}`,
					groupCellRender: ({ row, data: groupData, ...rest }) => {
						// console.log({ isExpanded, ...rest, groupData})
						const firstRowData = row.isExpanded ? groupData.items?.[0] : groupData.collapsedItems?.[0];
						return `${firstRowData?.shop?.name || ''} ${firstRowData?.parameters?.street || ''} ${firstRowData?.parameters?.postCode || ''} ${firstRowData?.parameters?.city || ''}`
					},
					groupIndex: 0,
					width: 150
				},
				// {
				// 	caption: t('options_section.strings.tse_tseInfo.parameters.city'),
				// 	dataField: 'parameters.city'
				// }, {
				// 	caption: t('options_section.strings.tse_tseInfo.parameters.postCode'),
				// 	dataField: 'parameters.postCode'
				// }, {
				// 	caption: t('options_section.strings.tse_tseInfo.parameters.street'),
				// 	dataField: 'parameters.street'
				// },
				{ ////
					caption: t('options_section.strings.tse_crType'),
					calculateCellValue: () => t('options_section.strings.tse_crTypeValue'),
					width: 150
					// Tablet-/App-Kassen-Systeme
				}, {
					caption: t('options_section.strings.tse_software'),
					dataField: 'tseInfo.software',
					cellRender: (rowState) => `${rowState.data.tseInfo?.software || ''} ${rowState.data.device?.appVersion || ''}`,
					width: 200
				}, {
					caption: t('options_section.strings.tse_hardwareId'),
					dataField: 'hardwareId',
					width: 150
				}, {
					caption: t('options_section.strings.tse_deviceVendor'),
					dataField: 'device.vendor',
					width: 150
				}, {
					caption: t('options_section.strings.tse_deviceModel'),
					dataField: 'device.model',
					width: 150
				}, {
					caption: t('options_section.strings.tse_firstTransaction'),
					dataField: 'firstTransaction',
					localFormat: {
						type: 'date'
					},
					width: 150
				}, { ////
					caption: t('options_section.strings.tse_serial'),
					dataField: 'tseInfo.serial'
				}, {
					caption: t('options_section.strings.tse_bsi'),
					dataField: 'tseInfo.bsi',
					width: 150
				}, {
					caption: t('options_section.strings.tse_activationDate'),
					dataField: 'tseInfo.activationDate',
					localFormat: {
						type: 'date'
					},
					width: 150
				}, {
					caption: t('options_section.strings.tse_type'),
					dataField: 'tseInfo.type',
					width: 150
				}, {
					caption: t('options_section.strings.tse_producer'),
					dataField: 'tseInfo.producer',
					width: 150
				}]}
				height={500}
				excelExport
			/>
		</ContentBlock>
	)
}

export default MeinElster
